import {
	FileNameCell,
	StyledDropzoneFileRow,
	StyledMoreVert,
	TimeSinceUploadCell,
} from './StylovyzeDropzone.styles';

import { AttachedFile } from '../../types/files';
import Check from '@mui/icons-material/Check';
import DeleteFile from './icons/DeleteFile';
import FilePaper from './icons/FilePaper';
import MenuListButton from '../../components/MenuListButton';
import React from 'react';
import { TableCell } from '@mui/material';
import { DateTime } from 'luxon';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
import { useSettings } from '../../contexts/Settings';

interface StylovyzeDropzoneRowProps {
	file: AttachedFile;
	onDownloadClick?: () => void;
	onDeleteClick?: () => void;
}

export const StylovyzeDropzoneRow = (props: StylovyzeDropzoneRowProps) => {
	const { t } = useGlobalization();
	const { companySettings } = useSettings();
	const locale = companySettings?.language.slice(0, 2) || 'en';
	const timeAgo = DateTime.fromMillis(
		// dateCreated is declared as a number but at runtime strings are passed
		new Date(props.file.dateCreated).getTime(),
		{
			locale: locale,
		},
	).toRelative();
	const menuItems: {
		text: string;
		icon: JSX.Element;
		onClick: () => void;
	}[] = [];
	const createMenu = () => {
		if (menuItems.length)
			return (
				<TableCell>
					<StyledMoreVert>
						<MenuListButton menuItems={menuItems} />
					</StyledMoreVert>
				</TableCell>
			);

		return null;
	};
	if (props.onDownloadClick)
		menuItems.push({
			text: t('Download', { context: 'File dropzone menu' }),
			icon: <Check />,
			onClick: props.onDownloadClick,
		});
	if (props.onDeleteClick)
		menuItems.push({
			text: t('Delete', { context: 'File dropzone menu' }),
			icon: <DeleteFile />,
			onClick: props.onDeleteClick,
		});
	return (
		<StyledDropzoneFileRow>
			<TableCell padding="checkbox">
				<FilePaper />
			</TableCell>
			<FileNameCell padding="none">{props.file.path}</FileNameCell>
			<TimeSinceUploadCell>{timeAgo}</TimeSinceUploadCell>
			{createMenu()}
		</StyledDropzoneFileRow>
	);
};

export default StylovyzeDropzoneRow;
